module.exports = __webpack_public_path__ + "static/img/man.0c2d27b7.webp";